"use strict";

import React from "react";
import { Button } from "reactstrap";
import { translate } from "react-i18next";
import { login, formatError } from "../helpers/firebase";
import {
  getMe,
  INACTIVE_SUBSCRIPTION_ERROR,
  checkSubscription,
} from "./../fetcher/api";
import Routes from "../../routes";
import { withStyles } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";
import { RouteReplace } from "../helpers/routing";
import { AvForm } from "availity-reactstrap-validation";
import AvCustomInput from "./AvCustomInput";

const styles = (theme) => ({
  progress: {
    margin: theme.spacing.unit * 2,
  },
});

class LoginForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: false,
      pending: false,
    };
  }

  async handleSubmit(values) {
    const { locale, t } = this.props;
    const { email, password } = values;

    this.setState({ pending: true, error: false });

    try {
      await login(email, password);
      sessionStorage.setItem("logged", "1");
      const profile = await getMe();
      checkSubscription(profile);
      RouteReplace("dashboard", locale);
    } catch (error) {
      const { code, message } = error || {};
      if (message === INACTIVE_SUBSCRIPTION_ERROR) {
        this.setState({ pending: false });
        return RouteReplace("inactive-subscription", locale);
      }

      this.setState({ error: t(formatError(code)), pending: false });
    }
  }

  render() {
    const { t, locale } = this.props;
    const { pending, error } = this.state;

    return (
      <div className="col-sm-12 col-md-6">
        <h2>{t("LOGIN")}</h2>
        <p className="form-input-error p-b-10">{error}</p>

        <AvForm onValidSubmit={(event, values) => this.handleSubmit(values)}>
          <AvCustomInput
            name="email"
            type="email"
            validate={{ email: true }}
            required={true}
            error={t("FORM_VALID_EMAIL")}
            label={t("EMAIL")}
          />
          <AvCustomInput
            name="password"
            type="password"
            required={true}
            error={t("FORM_FIELD_REQUIRED")}
            label={t("PASSWORD")}
          />

          <div className="row">
            <div className="col-6">
              <a href={Routes.findAndGetUrls("forgot", locale).urls.as}>
                <p>{t("LOST_PASSWORD")}</p>
              </a>
            </div>
          </div>

          {pending ? (
            <div className="row spinner-container">
              <CircularProgress className="spinner" />
            </div>
          ) : (
            <Button>{t("LOGIN_BTN_SUBMIT")}</Button>
          )}
        </AvForm>
      </div>
    );
  }
}

export default withStyles(styles)(translate(["common"])(LoginForm));



// WEBPACK FOOTER //
// src/components/LoginForm.js